module.exports = __webpack_public_path__ + "static/media/(V)-Prata-02.fba26748.jpg";